var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGolf = function SvgGolf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19 9.55c0 4.17-3.36 7.55-7.5 7.55S4 13.72 4 9.55 7.36 2 11.5 2 19 5.38 19 9.55m-4.96 3.68c.5 0 .91-.41.91-.92s-.41-.92-.91-.92-.91.41-.91.92.41.92.91.92m1.21-4.29c-.5 0-.91.41-.91.92s.41.92.91.92.91-.41.91-.92-.41-.92-.91-.92m-3.95 1.53c0 .51.41.92.91.92s.91-.41.91-.92-.41-.92-.91-.92-.91.41-.91.92m.6 2.45c0-.51-.41-.92-.91-.92s-.91.41-.91.92.41.92.91.92.91-.41.91-.92m-.4 5c1.57 0 3.1-.45 4.43-1.29.38-.24.88-.12 1.12.26.24.39.13.89-.25 1.13-1.36.86-2.9 1.38-4.49 1.51v1.67c0 .45-.36.82-.81.82s-.81-.37-.81-.82v-1.67a9.9 9.9 0 0 1-4.49-1.51.82.82 0 0 1-.25-1.13c.24-.39.74-.5 1.12-.26 1.32.84 2.86 1.29 4.43 1.29",
    clipRule: "evenodd"
  })));
};
export default SvgGolf;